import { UPGRADE_TRIGGERS } from '@shared/core/analytics'
import type { UpgradeTrigger } from '@shared/core/analytics'

export const PADDLE_CHECKOUT_LOADED_EVENT = 'Checkout.Loaded'

// Paddle Classic calls the Setup `eventCallback` with the options given to `Checkout.open` as `checkoutData`.
export type PaddleCheckoutEvent = {
  event?: string
  eventData?: unknown
  checkoutData?: {
    product?: number | string
    passthrough?: unknown
  }
}

export type PaddleCheckoutEventListener = (event: PaddleCheckoutEvent) => void

const listeners = new Set<PaddleCheckoutEventListener>()

export function dispatchPaddleCheckoutEvent(event: PaddleCheckoutEvent): void {
  listeners.forEach((listener) => {
    try {
      listener(event)
    } catch {
      // A failing listener must never break the checkout overlay.
    }
  })
}

export function subscribeToPaddleCheckoutEvents(listener: PaddleCheckoutEventListener): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export function readCheckoutPlanId(event: PaddleCheckoutEvent): number | undefined {
  const planId = Number(event?.checkoutData?.product)

  return Number.isInteger(planId) && planId > 0 ? planId : undefined
}

export function readCheckoutTrigger(event: PaddleCheckoutEvent): UpgradeTrigger | undefined {
  const passthrough = event?.checkoutData?.passthrough

  if (typeof passthrough !== 'string') {
    return undefined
  }

  try {
    const trigger: unknown = JSON.parse(passthrough)?.trigger

    return UPGRADE_TRIGGERS.find((candidate) => candidate === trigger)
  } catch {
    return undefined
  }
}
